<template>
  <div class="px-2 sm:px-0 w-full">
    <div class="flex w-full flex-col sm:flex-row sm:justify-between mb-3 sm:mb-5">
      <p class="self-start hidden sm:flex sm:self-blog text-xl font-bold text-purple_dark">
        {{blogs.length}} Blog Post(s)
      </p>
      <div class="self-end">
        <button
                @click="addBlog()"
                class="sm:w-full flex bg-transparent bg-purple_dark sideBackground text-white font-semibold hover:text-white py-2 px-4 hover: rounded-lg">

          Add Post
        </button>
      </div>
    </div>
    <div class="flex flex-wrap w-full">
      <div :key="blog.key" class="w-full lg:w-1/3  mb-3 sm:mb-6" v-for="blog in blogs">
        <div class="rounded-lg shadow-lg w-full bg-white sm:mr-4">
          <div :style="anotherStyles(blog)" class="imgg h-56 w-full bg-cover bg-center">
            <!--            <img :src="require('blog.post_image')" alt="Image">-->
          </div>
          <div class="w-full  p-3 ">
            <p class="text-2xl capitalize text-purple_dark font-medium mb-2">
              {{blog.title}}
            </p>
            <p class="truncate font-light mb-1">
              {{blog.description}}
            </p>
            <div class="flex justify-between mb-1">
              <p class="font-medium">
                <span class="italic pr-1">Posted by </span> {{blog.author}}
              </p>
              <p class="italic">
                {{blog.date}}
              </p>
            </div>
          </div>
          <div class="flex">
            <button
                    @click="editBlog(blog)"
                    class="w-1/2 bg-blue text-white flex justify-center font-semibold hover:text-white py-2 px-4 hover: rounded-bl-lg">
              <Edit3Icon></Edit3Icon>
            </button>
            <button
                    @click="deleteBlog(blog)"
                    class="w-1/2 bg-red-medium  flex justify-center text-white font-semibold hover:bg-red-dark py-2 px-4 hover: rounded-br-lg">
              <Trash2Icon></Trash2Icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Edit3Icon, Trash2Icon} from "vue-feather-icons";
  import {eventBus} from "../../eventbus";
  import {db} from "../../db";

  export default {
    name: "BlogContent",
    components: {
      Trash2Icon, Edit3Icon
    },
    props: {
      blogs: {
        type: Array
      },
      blogKeys: {
        type: Array
      }
    },
    computed: {},
    created() {
    },
    methods: {
      anotherStyles(x) {
        return `background-image: url(${x.post_image})`
      },
      addBlog() {
        eventBus.$emit('AddBlog')
      },
      editBlog(x) {
        eventBus.$emit('EditBlog', x)
      },
      // eslint-disable-next-line no-unused-vars
      deleteBlog(x) {
        this.$confirm(`Are you sure you want to delete ${x.title}?`, '',
            "error")
            .then(() => {
              let blog = this.blogKeys.find(item => item.title === x.title);
              db.ref('blog_post/' + `${blog.key}`).remove().then(() => {
                this.$toast.open({
                  message: 'Successful',
                  type: 'success'
                });
              })
            })
            .catch(() => {
            });

      }
    }
  }
</script>

<style scoped>

</style>
